import React from 'react'
import { locationMobx } from '@mobxStore'
import { toast } from '@utils'
import './index.scss'

interface IProps {
  setLBS?(res: {}): void;
}

const StoreTop = (props: IProps) => {
  const { getLocation } = locationMobx
  const { setLBS } = props
  const handleOpenLBS = () => {
    getLocation().then(res => {
      // 区分了国内和国外，没必要国际化
      if (res.error) {
        toast({ message: '获取定位信息失败' })
      }
      setLBS(res)
    }, err => {
      console.log(err, 222)
    })
  }
  return (
    <div className='store-top' onClick={handleOpenLBS}>
      <p>{i18n.t('store.noLocationTitle')}</p>
      <div className='button'>{i18n.t('store.noLocationButton')}</div>
    </div>
  )
}

export default StoreTop
